import { render } from "./QuestionReview.vue?vue&type=template&id=762df794&scoped=true"
import script from "./QuestionReview.vue?vue&type=script&lang=js"
export * from "./QuestionReview.vue?vue&type=script&lang=js"

import "./QuestionReview.vue?vue&type=style&index=0&id=762df794&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-762df794"]])

export default __exports__